import http from './http'

// 获取列表
export function pageList (queryString) {
  return http.get(`/client/user/activity?${queryString}`)
}

export function applyCode () {
  return http.get('/client/user/promotion/code')
}

export function getDetail (key) {
  return http.get(`/client/user/activity/${key}`)
}

export function pageListPromotion () {
  return http.get('/user/order/rebate/promotion_group/pagelist')
}

export function pagePromotion () {
  return http.get('/user/order/rebate/promotion/info')
}